import NestStore from "./NestStore";
import ConstantRepository from "../repository/ConstantRepository";
import i18n from "~/components/i18n";

class ConstantStore extends NestStore {
  static CONSTANTS = {
    TOUR_PROPERTY_TYPE: "tourPropertyTypes",
    TOUR_PROPERTY_STATUS: "tourPropertyStatuses",
    LOCALES: "locales",
    TIMEZONES: "timezones",
  };

  constructor() {
    super();
    this.constantRepository = new ConstantRepository();
  }

  #caching = {};

  load(constantList) {
    this.isLoading = true;
    const constantValues = Object.values(ConstantStore.CONSTANTS);
    const listToLoad = constantList.filter(
      constant => constantValues.includes(constant) && this.#caching[constant] === undefined,
    );
    if (!listToLoad.length) {
      this.isLoading = false;
      return;
    }
    const query = { modules: listToLoad };
    this.constantRepository.fetch(query).then(response => {
      if (response.data) {
        Object.keys(response.data).forEach(key => {
          if (constantValues.includes(key)) {
            this.#caching[key] = response.data[key];
          }
        });
      }
      this.isLoading = false;
    });
  }

  /**
   * Get list
   *
   * @param listName {ConstantStore.CONSTANTS}
   * @returns Object
   */
  getList(listName) {
    if (this.#caching[listName] === undefined) {
      return [];
    }

    return this.#caching[listName];
  }

  /**
   *
   * @param listName {ConstantStore.CONSTANTS}
   * @returns {{text: string, value: string, key: string}[]}
   */
  getFormList(listName) {
    if (this.#caching[listName] === undefined) {
      return [];
    }

    return Object.keys(this.#caching[listName]).map(key => {
      let domain = "";
      let translationKey = "";
      let newText = this.#caching[listName][key];

      // The translation for key when property type e.g. plumage:propertyTypeDetachedHome
      // The translation for key when property status e.g. plumage:propertyStatusAnnualRental
      if (listName === ConstantStore.CONSTANTS.TOUR_PROPERTY_TYPE) {
        domain = "plumage:";
        translationKey = "propertyType";
      } else if (listName === ConstantStore.CONSTANTS.TOUR_PROPERTY_STATUS) {
        domain = "plumage:";
        translationKey = "propertyStatus";
      } else if (listName === ConstantStore.CONSTANTS.TIMEZONES) {
        domain = "constants:";

        // No need for the rest for the timezones
        return { key, value: key, text: i18n.t(`${domain}${newText}`) };
      }

      // Replace - with space
      newText = newText.replace("-", " ");

      // All lowercase and split by space
      newText = newText.toLowerCase().split(" ");

      // Make the first character of every word capital
      newText = newText.map(word => word.charAt(0).toUpperCase() + word.slice(1));

      // Make the above a string and join them together
      newText = newText.join(" ");
      newText = newText.replace(/ /g, "");

      // If there is nothing at the translationKey
      // The first character of the newText needs to lowercase
      if (translationKey === "") {
        newText = newText.charAt(0).toLowerCase() + newText.slice(1);
      }

      translationKey += newText;

      return { key, value: key, text: i18n.t(`${domain}${translationKey}`) };
    });
  }
}
export default ConstantStore;
